module.exports = __webpack_public_path__ + "img/kkb_uvtube.ec94835c.jpg";